// @flow
import * as React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import classnames from 'classnames';
import map from 'lodash/map';

import useSiteInfo from '~hooks/useSiteInfo';
import RichText from '~plugins/prismic/components/RichText';
import FieldLink from '~plugins/prismic/components/FieldLink';
import ResPadding from '~plugins/material-ui/components/ResPadding';

import type { Props } from './types';
import styles from './styles';
import useFooterCopyright from './hooks/useFooterCopyright';

const Footer = ({ className, classes, ...props }: Props): React.Node => {
  const copyright = useFooterCopyright();
  const siteInfo = useSiteInfo();
  return (
    <div className={classnames(classes.root, className)} {...props}>
      <Container component={ResPadding} vertical className={classes.wrapper}>
        <RichText {...siteInfo?.data?.footer_title} />
        <div className={classes.content}>
          <RichText {...copyright} className={classes.copyright} />
          <div className={classes.actions}>
            {map(siteInfo?.data?.footer_actions, (action, index: number) =>
              action && action.action_label && action.action_label.text ? (
                <Button
                  key={index}
                  component={FieldLink}
                  field={action.action_link}
                  className={classes.link}
                >
                  {action.action_label?.text}
                </Button>
              ) : null,
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

Footer.defaultProps = {
  className: undefined,
};

export default withStyles<*, *, Props>(styles)(Footer);
